import PaginatedList from "#root/components/paginated-list";
import type { ReactNode } from "react";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import { currencyCollection } from "#root/schema/platform/reference-data";
import PageLayout from "./layout";

const title = (
  <Fragment>
    Currencies{" "}
    <Link className="button" to="/admin/platform/reference/currency/new">
      New Currency
    </Link>
  </Fragment>
);

export default function CurrencyPage(): ReactNode {
  return (
    <PageLayout title="Reference Platform - Currency">
      <PaginatedList title={title} collection={currencyCollection}>
        {({ rows }) => (
          <table>
            <thead>
            <tr>
              <th>Currency ID</th>
              <th>Name</th>
              <th>Code</th>
              <th>Action</th>
            </tr>
            </thead>
            <tbody>
            {rows.map(({ id, name, code }) => (
              <tr key={id}>
                <td>{id}</td>
                <td>{name}</td>
                <td>{code}</td>
                <td>
                  <Link to={`/admin/platform/reference/currency/${id}`}>Edit</Link>
                </td>
              </tr>
            ))}
            </tbody>
          </table>
        )}
      </PaginatedList>
    </PageLayout>
  );
}
